import React, { useEffect, useState } from 'react';
import SearchLicensesLine from '../SearchLicensesLine';
import { StyledLinksWrapper } from '../styledComponents';
import Button from '@atlaskit/button';
import t from 'modules/i18n/intl';

import Table from 'components/common/Table/Table';
import TableContent, { MACTableType } from 'modules/mac/table/TableContent';
import { messages } from 'modules/mac/messages';
import Loading from './LicensesSpinner';

const tableHeadersDefaultLicenses = [
  {
    display: 'SEN',
    key: 'licenses-sen',
    width: 20,
  },
  {
    display: 'Product',
    key: 'licenses-product',
    width: 30,
  },
  {
    display: 'Name',
    key: 'licenses-site-name',
    width: 15,
  },
  {
    display: 'Support Expires',
    key: 'licenses-support-expires',
    width: 15,
  },
  {
    display: 'Support',
    key: 'licenses-support',
    width: 20,
  },
];

const YourLicensesComponent = ({
  licenseItems,
  setLicensesToDisplay,
  updateSearchParams,
  partnerData,
  senNumber,
  preselectedLicenseBySen,
  isLicensesLoading,
  licensesToDisplay,
  isPartner,
}) => {
  const [isCollapsedAll, setIsCollapsedAll] = useState(false);

  useEffect(() => {
    if (isCollapsedAll) {
      setIsCollapsedAll(false);
    }
  }, [isCollapsedAll]);

  const handleCollapseAll = () => {
    setIsCollapsedAll(true);
  };
  return (
    <>
      <SearchLicensesLine
        allLicenses={licenseItems}
        updateLicensesToDisplay={setLicensesToDisplay}
        updateSearchParams={updateSearchParams}
        isPartner={false}
        partnerId={partnerData?.id}
        senNumber={senNumber}
        preselectedLicenseBySen={preselectedLicenseBySen}
      />
      <StyledLinksWrapper>
        <Button appearance="link" onClick={handleCollapseAll}>
          {t(messages.licensesCollapseAll)}
        </Button>
      </StyledLinksWrapper>
      <Table
        body={
          !isLicensesLoading ? (
            <TableContent
              items={licensesToDisplay}
              tableType={MACTableType.licenses}
              senNumber={senNumber}
              isCollapsedAll={isCollapsedAll}
              endUserView={false}
              isPartner={isPartner}
            />
          ) : (
            <Loading endUserLicensesTabIsChosen={false} />
          )
        }
        footers={[]}
        headers={tableHeadersDefaultLicenses}
        dataAttr="licenses"
      />
    </>
  );
};

export default YourLicensesComponent;
